import React, { Component } from 'react'


export default class ShareCam extends Component {

    componentDidMount() {

        const video = document.getElementById('videoContainer')
        
        navigator.mediaDevices.getUserMedia({ video: true, audio: false })
        .then( stream => {
            video.srcObject = stream
            video.play()
        })
        .catch(err => {
          console.error('Error', err)
        })

        video.addEventListener('canplay', this.playFx)
        
    }

    
    componentWillUnmount() {
        const video = document.getElementById('videoContainer')
        const stream = video.srcObject
        stream.getTracks().forEach(function(track) { track.stop() })
    }


    playFx = () => {

        const video = document.getElementById('videoContainer')
        const canvas = document.querySelector('.photo')
        const ctx = canvas.getContext('2d')
        const width = video.videoWidth
        const height = video.videoHeight
        canvas.width = width
        canvas.height = height
      
        return setInterval(() => {

            ctx.drawImage(video, 0, 0, width, height);
       
        }, 16)

    }


    takeFx = () => {

        const canvas = document.querySelector('.photo')
        const strip = document.querySelector('.strip')

        const data = canvas.toDataURL('image/jpeg')
        const link = document.createElement('a')
        link.href = data;
        link.setAttribute('download', 'picture')
        link.innerHTML = `<img src="${data}" alt="picture" />`
        strip.insertBefore(link, strip.firsChild)
        
    }


    closeFx = () => {

        this.props.closeMe()
        
    }

    render() {

		return (

            <div className='NightWrapper'>

	            <div id='videoBox'>
                
                    <canvas className='photo'></canvas>
	                <video id='videoContainer'></video>
                    <div className='strip'></div>

	                <div id='videoMenu'>
	                    <span onClick={this.takeFx}>TAKE</span>
	                    <span onClick={this.closeFx}>LEAVE</span>
	                </div>

	            </div>
            </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/share/ShareCam.js